import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Spacings } from '@styles/index';
import { useIsMobile } from '@stores/AppCommonData';
import ShowCase from 'aquilla/core/molecules/ShowCase';
import pushRoute from '@utils/pushRoute';
import PlusCourseCard from '@comp/PlusCourseCard/AquillaPlusCourseCard';
import EducatorLegendsBanner from './EducatorLegendsBanner';

const SingleFeedContainer = styled.div`
  margin: ${Spacings.SPACING_12B} 0 ${Spacings.SPACING_6B};
`;

const StyledShowCase = styled(ShowCase)`
  grid-column: span 18;
`;

const SingleFeedBlock = ({
  isBannerPresent,
  username,
  profileFeed,
  isEducatorPage = null
}) => {
  const feedBlock = profileFeed.results?.[isBannerPresent ? 1 : 0];
  const isMobile = useIsMobile();
  let routeURL = 'courses';
  if (isEducatorPage) routeURL = isEducatorPage;
  if (!feedBlock) return null;
  const gridColumn = isMobile ? 'span 10' : 'span 6';

  function handleSeeAll() {
    const filtersApplied = feedBlock.extraBlockInfo?.filtersApplied;
    const seeAllLink = `/@${username}/${routeURL}/?goal=${
      filtersApplied?.goal?.id || 'all'
    }&type=${filtersApplied?.filterBy?.id}`;

    const href = {
      pathname: `/[authorID]/${routeURL}`,
      query: {
        goal: filtersApplied?.goal?.id,
        type: filtersApplied?.filterBy?.id
      }
    };
    pushRoute(href, seeAllLink);
  }

  return (
    <SingleFeedContainer>
      {isBannerPresent ? (
        <EducatorLegendsBanner
          course={profileFeed.results?.[0].data[0]}
          label={profileFeed.results[0]?.type}
        />
      ) : null}
      <StyledShowCase
        title={feedBlock.label}
        itemsPerSlide={3}
        onSeeAll={feedBlock?.extraBlockInfo?.seeAllLink ? handleSeeAll : null}
      >
        {feedBlock.courses?.map((course, index) => (
          <PlusCourseCard
            course={course}
            key={course.uid}
            gridColumn={gridColumn}
            marginBottom={Spacings.SPACING_8B}
            index={index}
            label={feedBlock.label}
          />
        ))}
      </StyledShowCase>
    </SingleFeedContainer>
  );
};

export default SingleFeedBlock;

SingleFeedBlock.propTypes = {
  isBannerPresent: PropTypes.bool,
  username: PropTypes.string.isRequired,
  profileFeed: PropTypes.objectOf(PropTypes.any)
};

SingleFeedBlock.defaultProps = {
  isBannerPresent: false,
  profileFeed: {}
};
